type LogoMarkProps = {
  className?: string;
};

export function LogoMark({ className = "" }: LogoMarkProps) {
  return (
    <span className={`logo-mark ${className}`.trim()} aria-hidden="true">
      <svg viewBox="0 0 48 48" focusable="false">
        <rect className="logo-mark-bg" x="4" y="4" width="40" height="40" rx="10" />
        <path className="logo-mark-line" d="M15 25.5 24 16.5l9 9" />
        <path className="logo-mark-line" d="M18.5 25.5v9h11v-9" />
        <path className="logo-mark-flow" d="M14.5 34.5c5.6-5.7 13.7 5.7 19-1.8" />
        <circle className="logo-mark-dot" cx="33.5" cy="32.7" r="2.6" />
      </svg>
    </span>
  );
}
